module.exports = __webpack_public_path__ + "static/media/stripe.03262c4c.svg";